import type { ResourceConfig } from '../../interfaces/ResourceConfig';
import { configStack } from './configStack';
import { mergeResourceConfig } from '../mergeResourceConfig';

/**
 * @internal
 * Merge all configs in the stack (bottom to top, later configs override earlier ones)
 */
export function getMergedConfig(): ResourceConfig | null {
  if (configStack.length === 0) {
    return null;
  }

  // Start with first config
  let merged: ResourceConfig = { ...configStack[0] };

  // Merge each subsequent config using the centralized merge function
  for (let i = 1; i < configStack.length; i++) {
    merged = mergeResourceConfig(merged, configStack[i]);
  }

  return merged;
}

